<script setup lang="ts">
import { watch } from 'vue'
import { ElMessage } from 'element-plus'

interface ErrorMessageObj {
  error: Record<string, unknown>
  message: string
}

interface PropTypes {
  errors: Array<ErrorMessageObj | Record<string, unknown>>
}

const props = defineProps<PropTypes>()

const openErrorMessage = (message: string): void => {
  ElMessage.error({
    message: message,
  })
}

watch(props.errors, () => {
  const lastError = props.errors[props.errors.length - 1]
  let message = lastError?.message
  if (message) openErrorMessage(message as string)
})
</script>

<template>
  <span></span>
</template>
